export const Events = () => {
    return (
        <div>
            <h5>Events</h5>
        </div>
    );
}